import React, { useState } from "react";
import requestAPI from "../../../../utils/requestAPI";
import settings, { AmenityType } from "../../../../apiConfigs/settings";
import { toast } from "react-toastify";
import { ModalContainerStyled } from "../../../../designComponents/Modal/style";
import Modal from "../../../../designComponents/Modal";
import { Form, Formik } from "formik";
import { InfoRowStyled, NewLandlordWrapper } from "../../../Users/style";
import Typography from "../../../../designComponents/Typography";
import Input from "../../../../designComponents/Input";
import Button from "../../../../designComponents/Button";
import theme from "../../../../theme";
import UploadFile from "../../../../designComponents/UploadFile";
import { uploadFilesToS3OnlyKeys } from "../../../../utils/s3Upload";

type Props = {
  isOpenModal: boolean;
  onClose: () => void;
  refreshData: Function;
  initialValues: AmenityType;
};

const AddAmenity = ({
  isOpenModal,
  onClose,
  refreshData,
  initialValues,
}: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState("");

  const amenityId = initialValues?._id;

  const handleAddAmenity = async (values: AmenityType) => {
    setLoading(true);
    let amenityUrl = "";

    try {
      if (values.avatar && typeof values.avatar !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          fileUri: [values.avatar],
          category: "assets",
          assetsCategory: "amenity",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          amenityUrl = uploadFiles[0];
        }
      } else if (typeof values.avatar === "string") {
        amenityUrl = values.avatar;
      }

      await requestAPI(
        settings.addAmenity({
          title: values.title,
          icon: amenityUrl || "",
        })
      );
      setLoading(false);
      onClose();
      refreshData();
      toast.success("Amenity added successfully");
    } catch (error: any) {
      console.log(error);
      setErrorMessage(error.message);
      setLoading(false);
    }
  };

  const handleUpdateAmenity = async (
    amenityId: string,
    values: AmenityType
  ) => {
    setLoading(true);
    let amenityUrl = "";

    try {
      if (values.avatar && typeof values.avatar !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({category:'assets',fileUri:[values.avatar],assetsCategory:'resource'});
        if (uploadFiles && uploadFiles.length > 0) {
          amenityUrl = uploadFiles[0];
        }
      } else if (typeof values.avatar === "string") {
        amenityUrl = values.avatar;
      }

      await requestAPI(
        settings.updateAmenity(amenityId, {
          title: values.title,
          avatar: amenityUrl || "",
        })
      );
      setLoading(false);
      onClose();
      refreshData();
      toast.success("Amenity updated successfully");
    } catch (error: any) {
      console.log(error);
      setErrorMessage(error.message);
      setLoading(false);
    }
  };

  return (
    <ModalContainerStyled>
      <Modal
        isOpen={isOpenModal}
        onClose={onClose}
        title={amenityId ? "Update Amenity" : "Create New Amenity"}
        halfWidth={true}
      >
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            if (amenityId) {
              handleUpdateAmenity(amenityId, values);
            } else {
              handleAddAmenity(values);
            }
          }}
          enableReinitialize={true}
        >
          {({ values, setFieldValue, handleSubmit, errors, touched }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <NewLandlordWrapper>
                  <InfoRowStyled>
                    <Typography
                      fontFamily="roboto"
                      size="normal"
                      fontWeight="medium"
                      color="dark.neutral_45"
                    >
                      Title <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Input
                      name="name"
                      value={values.title}
                      onChange={(e) => setFieldValue("title", e.target.value)}
                    />
                    {errors.title && touched.title && (
                      <div style={{ color: "red" }}>{errors.title}</div>
                    )}
                  </InfoRowStyled>

                  <InfoRowStyled>
                    <Typography
                      fontFamily="roboto"
                      size="normal"
                      fontWeight="medium"
                      color="dark.neutral_45"
                    >
                      Icon <span style={{ color: "red" }}>*</span>
                    </Typography>

                    <UploadFile
                      title="Upload Icon"
                      name="avatar"
                      variant="previewImage"
                      onChange={(file) => setFieldValue("avatar", file)}
                      apiUrls={
                        values.avatar && typeof values.avatar === "string"
                          ? [values.avatar]
                          : []
                      }
                      onRemove={() => {
                        setFieldValue("avatar", null);
                      }}
                      enableMultipleFile={false}
                    />
                  </InfoRowStyled>
                </NewLandlordWrapper>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "50px",
                  }}
                >
                  <Button
                    radius="md"
                    variant="ghost"
                    style={{
                      border: `1px solid ${theme.colors.dark.neutral_250}`,
                      borderRadius: "10px",
                      color: theme.colors.text,
                      fontFamily: theme.fontFamily.roboto,
                      fontWeight: theme.fontWeights.medium,
                    }}
                    onClick={() => onClose()}
                  >
                    cancel
                  </Button>
                  <Button
                    type="submit"
                    radius="normal"
                    isLoading={loading}
                    style={{ backgroundColor: theme.colors.brandColorBlue }}
                  >
                    {amenityId ? "Update" : "Save"}
                  </Button>
                </div>
                {errorMessage && (
                  <div style={{ color: "red", marginTop: "10px" }}>
                    {errorMessage}
                  </div>
                )}
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </ModalContainerStyled>
  );
};

export default AddAmenity;
